/**
 * Intent chips for PlaceCore "Passar bra för" section.
 * These are distinct from place tags – intents describe visitor use-cases.
 */
export const INTENT_OPTIONS = [
  { value: "rorelse", label: "Rörelse" },
  { value: "smaka", label: "Smaka" },
  { value: "stillhet", label: "Stillhet" },
  { value: "lara", label: "Lära" },
  { value: "umgas", label: "Umgås" },
  { value: "lek", label: "Lek" },
] as const;

export type IntentValue = (typeof INTENT_OPTIONS)[number]["value"];

/**
 * Season chips for multi-select. No "multi" option — users select
 * individual seasons instead.
 */
export const SEASON_CHIP_OPTIONS = [
  { value: "spring", label: "Vår" },
  { value: "summer", label: "Sommar" },
  { value: "autumn", label: "Höst" },
  { value: "winter", label: "Vinter" },
] as const;

export type SeasonValue = (typeof SEASON_CHIP_OPTIONS)[number]["value"];

/**
 * Duration select options. First option is "no value".
 */
export const DURATION_OPTIONS = [
  { value: "none", label: "Ingen angiven" },
  { value: "lt_1h", label: "Kort stopp" },
  { value: "1_3h", label: "1–3 timmar" },
  { value: "half_day", label: "Halvdag" },
  { value: "full_day", label: "Heldag" },
] as const;

export type DurationValue = (typeof DURATION_OPTIONS)[number]["value"];
